import React, { Component } from 'react'

import Firebase from "firebase/app"
import 'firebase/database'

import EventsFinder from './CustomAdminComponents/EventsFinder'
import EventsTable from './CustomAdminComponents/EventsTable'
import EventDisplay from './CustomAdminComponents/EventDisplay'
import EventsSheetExporter from './CustomAdminComponents/EventsSheetExporter'

import {FaPlus} from 'react-icons/fa'
import {ThemeProvider} from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'

import {
    appTheme,
    filterEvents,
    getVisitHours,
    validateField,
    downloadReservations,
    sendEventEmail
} from '../../utils'

import {
    CREATE_STATE,
    FOUND_STATE,
    DELETED_STATE,
    CREATE_SUCCESS_STATE,
    UPDATE_STATE,
    UPDATE_SUCCESS_STATE,
    NOT_CHOOSEN_STATE,
    ID_FIELD,
    NUMBER_FIELD,
    MAIL_FIELD,
    NAME_FIELD
} from "../../constants"


class EventsAdmin extends Component {

    constructor(props) {
        super(props)
        this.state = {
            eventsState: NOT_CHOOSEN_STATE,
            eventToFind: {
                id: '',
                client_id: '',
                name: '',
                room_id: '',
                eventDate: null,
                errorMessages: {
                    invalidId: false,
                    invalidClientId: false,
                    invalidName: false
                }
            },
            reservations: {},
            eventsFound: {},
            selectedEvent: {},
            selectedEventId: null,
            availableRooms: {},
            errorMessages: {
                invalidName: false,
                invalidClientId: false,
                invalidClientMail: false,
                invalidTimeRange: false,
                invalidReservedSpaces: false,
                invalidRoom: false
            }
        }

        this.guestsDBRef = Firebase.database().ref(`/guests/`)
        this.handleSearchButton = this.handleSearchButton.bind(this)
        this.handleIdEventChange = this.handleIdEventChange.bind(this)
        this.handleClientIdEventChange = this.handleClientIdEventChange.bind(this)
        this.handleNameChange = this.handleNameChange.bind(this)
        this.handleRoomChange = this.handleRoomChange.bind(this)
        this.handleDateChange = this.handleDateChange.bind(this)
        this.handleEventCreate = this.handleEventCreate.bind(this)
        this.handleEventSubmit = this.handleEventSubmit.bind(this)
        this.handleSelectedEventChange = this.handleSelectedEventChange.bind(this)
        this.handleEventUpdate = this.handleEventUpdate.bind(this)
        this.handleEventDelete = this.handleEventDelete.bind(this)
        this.handleReservationsDownload = this.handleReservationsDownload.bind(this)
    }

    // EventsFinderInputsValidation
    handleIdEventChange(event){
        const {eventToFind} = this.state
        const newEventId = event.target.value.trim()
        if (newEventId.length > 9){
            return
        }
        if (!validateField(ID_FIELD, newEventId) && newEventId.length > 0){
            eventToFind.errorMessages.invalidId = true
        } else {
            eventToFind.errorMessages.invalidId = false
        }
        eventToFind.id = newEventId
        this.setState({
            eventsState: NOT_CHOOSEN_STATE,
            eventToFind: eventToFind
        })
    }

    handleReservationsDownload(){
        const {selectedEventId, reservations} = this.state
        downloadReservations(reservations, selectedEventId)
    }

    handleClientIdEventChange(event){
        const {eventToFind} = this.state
        const newClientId = event.target.value.trim()
        if (newClientId.length > 15){
            return
        }
        if (!validateField(NUMBER_FIELD, newClientId) && newClientId.length > 0){
            eventToFind.errorMessages.invalidClientId = true
        } else {
            eventToFind.errorMessages.invalidClientId = false
        }
        eventToFind.client_id = newClientId
        this.setState({
            eventsState: NOT_CHOOSEN_STATE,
            eventToFind: eventToFind
        })
    }

    handleNameChange(event){
        const {eventToFind} = this.state
        const newName = event.target.value
        if (newName.length > 30){
            return
        }
        if (!validateField(NAME_FIELD, newName) && newName.length > 0){
            eventToFind.errorMessages.invalidName = true
        } else {
            eventToFind.errorMessages.invalidName = false
        }
        eventToFind.name = newName
        this.setState({
            eventsState: NOT_CHOOSEN_STATE,
            eventToFind: eventToFind
        })
    }

    handleRoomChange(event){
        const {eventToFind} = this.state
        const roomId = event.target.value
        eventToFind.room_id = roomId
        this.setState({
            eventsState: NOT_CHOOSEN_STATE,
            eventToFind: eventToFind
        })
    }

    handleDateChange(dateInput){
        const {eventToFind} = this.state
        eventToFind.eventDate = dateInput
        this.setState({
            eventsState: NOT_CHOOSEN_STATE,
            eventToFind: eventToFind
        })
    }

    handleSearchButton(){
        const {eventToFind} = this.state
        const {guestsDBRef} = this
        guestsDBRef.off()
        // Handle easy case first
        var newEventsFound = {}
        if (eventToFind.id){
            const eventId = eventToFind.id
            const ref = Firebase.database().ref(`/events/${eventId}`)
            ref.on('value', snapshot => {
                var eventRaw = snapshot.val();
                if (eventRaw !== null){
                    newEventsFound[eventId] = eventRaw
                }
                this.setState({
                    eventsFound: newEventsFound,
                    eventsState: FOUND_STATE
                })
            })
            return
        }
        // If we do not have the id, then we will have to download all events
        const ref = Firebase.database().ref(`/events/`)
        ref.on('value', snapshot => {
            var eventsRaw = snapshot.val()
            if (eventsRaw !== null){
                newEventsFound = filterEvents(eventsRaw, eventToFind)
            }
            this.setState({
                eventsFound: newEventsFound,
                eventsState: FOUND_STATE,
            })
        })
    }

    handleEventUpdate(eventId){
        const {eventsFound, availableRooms} = this.state
        const {guestsDBRef} = this
        guestsDBRef.off()
        if (!Object.keys(availableRooms).includes(eventsFound[eventId].room.id)){
            // if the room no longer exists, clean room
            eventsFound[eventId].room = {id: 'all'}
        }
        guestsDBRef.child(`${eventId}`).on('value', snapshot => {
            var reservationsRaw = snapshot.val()
            if (reservationsRaw == null){
                reservationsRaw = {}
            }
            this.setState({
                reservations: reservationsRaw
            })
        })
        this.setState({
            eventsState: UPDATE_STATE,
            selectedEvent: eventsFound[eventId],
            selectedEventId: eventId,
            errorMessages: {
                invalidName: false,
                invalidClientId: false,
                invalidTimeRange: false,
                invalidReservedSpaces: false
            }
        })
    }

    handleEventDelete(){
        const {selectedEventId} = this.state
        const {guestsDBRef} = this
        guestsDBRef.off()
        const eventUrl = `/events/${selectedEventId}`
        Firebase.database().ref(eventUrl).remove()
        guestsDBRef.child(`${selectedEventId}`).remove()
        this.setState({
            eventsState: DELETED_STATE,
            errorMessages: {
                invalidName: false,
                invalidClientId: false,
                invalidTimeRange: false,
                invalidReservedSpaces: false
            }
        })
    }

    handleEventCreate(){
        const {guestsDBRef} = this
        guestsDBRef.off()
        const emptyEvent = {
            availableHours: [],
            client_id: '',
            client_mail: '',
            end: new Date().getTime(),
            start: new Date().getTime(),
            name: '',
            reservedSpaces: 0,
            room: {id: 'all'}
        }
        const eventId = Math.random().toString(36).substr(2, 9)
        this.setState({
            eventsState: CREATE_STATE,
            selectedEvent: emptyEvent,
            selectedEventId: eventId,
            eventsFound: {},
            errorMessages: {
                invalidName: false,
                invalidClientId: false,
                invalidClientMail: false,
                invalidTimeRange: false,
                invalidReservedSpaces: false
            }
        })
    }

    handleEventSubmit(){
        const {selectedEvent, selectedEventId, eventsState, errorMessages} = this.state
        const availableHours = getVisitHours(selectedEvent.start, selectedEvent.end)
        // Check errors
        if (selectedEvent.room.id === 'all'){
            errorMessages.invalidRoom = true
            this.setState({
                errorMessages: errorMessages
            })
            return
        }
        if (selectedEvent.client_id.length === 0){
            errorMessages.invalidClientId = true
            this.setState({
                errorMessages: errorMessages
            })
            return
        }
        if (selectedEvent.name.length === 0){
            errorMessages.invalidName = true
            this.setState({
                errorMessages: errorMessages
            })
            return
        }
        if (selectedEvent.reservedSpaces.length === 0){
            errorMessages.invalidReservedSpaces = true
            this.setState({
                errorMessages: errorMessages
            })
            return
        }
        if (selectedEvent.start >= selectedEvent.end){
            errorMessages.invalidTimeRange = true
            this.setState({
                errorMessages: errorMessages
            })
            return
        }
        if (eventsState === CREATE_STATE){
            // Set occupation for all visit hours as 0
            for (var index in availableHours){
                selectedEvent.availableHours[availableHours[index]] = 0
            }
        }
        selectedEvent.reservedSpaces = Number(selectedEvent.reservedSpaces)
        Firebase.database().ref(`/events/${selectedEventId}`).set(selectedEvent)
        sendEventEmail(selectedEventId, selectedEvent)
        this.setState({
            eventsState: eventsState === CREATE_STATE ? CREATE_SUCCESS_STATE : UPDATE_SUCCESS_STATE
        })
    }

    handleSelectedEventChange(key, value){
        const {selectedEvent, errorMessages, availableRooms} = this.state
        if (key === 'client_id'){
            const newClientId = value.trim().replace('-', '')
            if (newClientId.length > 15){
                return
            }
            if (!validateField(NUMBER_FIELD, newClientId) && newClientId.length > 0){
                errorMessages.invalidClientId = true
            } else {
                errorMessages.invalidClientId = false
            }
            selectedEvent.client_id = newClientId
        }
        else if (key === 'client_mail'){
            const newClientMail = value.trim()
            if (!validateField(MAIL_FIELD, newClientMail) && newClientMail.length > 0){
                errorMessages.invalidClientMail = true
            } else {
                errorMessages.invalidClientMail = false
            }
            selectedEvent.client_mail = newClientMail
        }
        else if (key === 'name'){
            if (value.length > 30){
                return
            }
            if (!validateField(NAME_FIELD, value) && value.length > 0){
                errorMessages.invalidName = true
            } else {
                errorMessages.invalidName = false
            }
            selectedEvent.name = value
        }
        else if (key === 'room_id'){
            if (value === 'all'){
                errorMessages.invalidRoom = true
            } else {
                errorMessages.invalidRoom = false
            }
            selectedEvent.room = availableRooms[value]
            selectedEvent.room.id = value
        }
        else if (key === 'reservedSpaces'){
            const newValue = value.trim()
            if (!validateField(NUMBER_FIELD, value) && newValue.length > 0){
                errorMessages.invalidReservedSpaces = true
            } else {
                errorMessages.invalidReservedSpaces = false
            }
            selectedEvent.reservedSpaces = newValue
        }
        else if (key === 'startDate'){
            // Set it to start time
            const startDate = new Date(selectedEvent.start)
            value.setHours(startDate.getHours(), startDate.getMinutes())
            selectedEvent.start = value.getTime()
            if (selectedEvent.end <= selectedEvent.start){
                errorMessages.invalidTimeRange = true
            } else {
                errorMessages.invalidTimeRange = false
            }
        }
        else if (key === 'startTime'){
            const startDate = new Date(selectedEvent.start)
            const hours = Number(value.substring(0, value.indexOf(':')))
            const minutes = Number(value.substring(value.indexOf(':') + 1))
            if (isNaN(hours) || isNaN(minutes)){
                return
            }
            startDate.setHours(hours, minutes)
            selectedEvent.start = startDate.getTime()
            if (selectedEvent.end <= selectedEvent.start){
                errorMessages.invalidTimeRange = true
            } else {
                errorMessages.invalidTimeRange = false
            }
        }
        else if (key === 'endDate'){
            // Set it to start time
            const endDate = new Date(selectedEvent.end)
            value.setHours(endDate.getHours(), endDate.getMinutes())
            selectedEvent.end = value.getTime()
            if (selectedEvent.end <= selectedEvent.start){
                errorMessages.invalidTimeRange = true
            } else {
                errorMessages.invalidTimeRange = false
            }
        }
        else if (key === 'endTime'){
            const endDate = new Date(selectedEvent.end)
            if (value){
                const hours = Number(value.substring(0, value.indexOf(':')))
                const minutes = Number(value.substring(value.indexOf(':') + 1))
                if (isNaN(hours) || isNaN(minutes)){
                    return
                }
                endDate.setHours(hours, minutes)
                selectedEvent.end = endDate.getTime()
                if (selectedEvent.end <= selectedEvent.start){
                    errorMessages.invalidTimeRange = true
                } else {
                    errorMessages.invalidTimeRange = false
                }
            }
        }

        this.setState({
            selectedEvent: selectedEvent,
            errorMessages: errorMessages
        })

    }

    componentDidMount(){
        const {eventToFind} = this.state
        const ref = Firebase.database().ref(`/rooms/`)
        ref.on('value', snapshot => {
            var rooms = snapshot.val()
            if (rooms === null){
                rooms = {}
            }
            // Insert a room that will act as "search all" option
            rooms['all'] = {
                name: '**Todas',
                capacity: 0,
                available: true
            }
            eventToFind.room_id = 'all'
            this.setState({
                availableRooms: rooms,
                eventToFind: eventToFind
            })
        })
    }

    render(){
        const {
            eventToFind, availableRooms, eventsFound, eventsState, selectedEvent,
            errorMessages, selectedEventId, reservations
        } = this.state
        const {
            handleSearchButton,
            handleIdEventChange,
            handleClientIdEventChange,
            handleNameChange,
            handleRoomChange,
            handleDateChange,
            handleEventCreate,
            handleSelectedEventChange,
            handleEventSubmit,
            handleEventUpdate,
            handleEventDelete,
            handleReservationsDownload
        } = this
        return(
            <div className="guests-block">
                <div className="guests-block">
                    <div className="events-finder-container personal-data-block">
                        <EventsFinder
                            eventData={eventToFind}
                            eventsFound={eventsState === FOUND_STATE}
                            availableRooms={availableRooms}
                            onSearchClick={handleSearchButton}
                            onEventIdChange={handleIdEventChange}
                            onClientIdChange={handleClientIdEventChange}
                            onNameChange={handleNameChange}
                            onRoomChange={handleRoomChange}
                            onDateChange={handleDateChange}
                        />
                    </div>
                    <div className="personal-data-block events-finder-container">
                        <div>
                            <div className="line-header-text">Otras opciones</div>
                            <ThemeProvider theme={appTheme}>
                                <Button color="primary" variant="contained" onClick={handleEventCreate} disabled={false}>
                                    <FaPlus/>Añadir evento
                                </Button>
                            </ThemeProvider>
                        </div>
                        <div className="event-admin-events-exporter">
                            <EventsSheetExporter />
                        </div>
                    </div>
                </div>
                <div className="shadow-box"></div>
                <div>
                {
                    [FOUND_STATE, UPDATE_STATE, UPDATE_SUCCESS_STATE, DELETED_STATE].includes(eventsState) ?
                    <div className="events-finder-container">
                        <EventsTable
                            events={eventsFound}
                            onEventIdClick={handleEventUpdate}
                        />
                    </div>:<div></div>
                }
                </div>
                <div className="display-block-container">
                {   [
                        CREATE_STATE,
                        CREATE_SUCCESS_STATE,
                        UPDATE_STATE,
                        UPDATE_SUCCESS_STATE,
                        DELETED_STATE
                    ].includes(eventsState) ?
                    <div className="events-finder-container">
                        <EventDisplay
                            eventData={selectedEvent}
                            eventId={selectedEventId}
                            availableRooms={availableRooms}
                            errorMessages={errorMessages}
                            onEventChange={handleSelectedEventChange}
                            eventsState={eventsState}
                            reservations={reservations}
                            onSubmit={handleEventSubmit}
                            onReservationDownload={handleReservationsDownload}
                            onDelete={handleEventDelete}
                        />
                    </div> : <div></div>
                }
                </div>
            </div>
        )
    }
}

export default EventsAdmin
